import React from 'react';
import { theme } from '../../theme';
import { Container, StepButton } from './styled';
import { DownArrowIcon } from '../../tempIcons/DownArrowIcon';
import { UpArrowIcon } from '../../tempIcons/UpArrowIcon';
export const Stepper = ({ onIncrement, onDecrement, disabled = false, size }) => (React.createElement(Container, { size: size },
    React.createElement(StepButton, { type: "button", onClick: onIncrement, disabled: disabled },
        React.createElement(UpArrowIcon, { height: theme.sizes.base, width: theme.sizes.base, color: theme.colors.neutral.ink.base })),
    React.createElement(StepButton, { type: "button", onClick: onDecrement, disabled: disabled },
        React.createElement(DownArrowIcon, { height: theme.sizes.base, width: theme.sizes.base, color: theme.colors.neutral.ink.base }))));
//# sourceMappingURL=Stepper.js.map